<template>
    <div class="venue-snippet" :class="{ active }" @click="editable ? $emit('open') : ''">
        <div class="venue-image" :style="`background-image: url(${venue.logoUrl});`"></div>
        <div class="text-container">
            <div class="title copy-l bold" :title="venue.name">{{ venue.name }}</div>
            <div class="description">
                <div class="rating">
                    <FeatherIcon
                        v-for="star in 5"
                        :key="star"
                        :class="star <= Math.floor(venue.sourceStarRating) ? 'active' : ''"
                        name="star"
                    />
                </div>
                <div class="text copy-m">
                    <div v-if="venue.priceLevel" class="price">
                        <div v-for="euro in venue.priceLevel" :key="euro" class="euro">€</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="editable" class="edit">
            <FeatherIcon name="edit" />
        </div>
    </div>
</template>

<script>
import FeatherIcon from '@/components/FeatherIcon'
export default {
    name: 'ClubSnippet.vue',
    components: {
        FeatherIcon,
    },
    props: {
        venue: {
            type: Object,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        percentage() {
            return (this.current / this.realMax) * 100
        },
        realMax() {
            if (this.venue) {
                return this.venue.capacity ? this.venue.capacity : this.max
            } else {
                return this.max
            }
        },
    },
}
</script>

<style scoped lang="sass">
.venue-snippet
    display: flex
    align-items: center

    .edit
        margin-right: $xs
        .feather-icon
            width: 20px

            &::v-deep
                svg
                    stroke: $neutral-2
    .text-container
        flex: 1

        .description
            display: flex
            align-items: center

            .rating
                display: flex
                align-items: center

                .feather-icon
                    width: 18px
                    &::v-deep
                        svg
                            stroke: $neutral-2

                    &.active
                        &::v-deep
                            svg
                                fill: $neutral-2

            .text
                display: flex
                color: $neutral-2

                .price
                    display: flex
                    align-items: center

                & > div
                    &:before
                        content: '·'
                        margin: 0 $xxs


        .title
            white-space: nowrap
            max-width: 250px
            text-overflow: ellipsis
            overflow: hidden
            padding-right: $l

        .time
            color: $neutral-2

    .venue-image
        width: 6.4rem
        min-width: 6.4rem
        height: 6.4rem
        background: $gray-1
            size: cover
            position: center
        border-radius: 8px
        margin-right: $l
        box-shadow: $precise
</style>
